<template>
    <div
        style="height: 100%; overflow: hidden; font-family: Arial, Helvetica, sans-serif"
        :style="{
            '--iframe-background-color': setting.BackgroundColor!,
            '--iframe-text-color': setting.ForegroundColor!,
            '--iframe-font-size': setting.FontSize! + '%',
        }"
    >
        <div
            style="
                gap: 1em;
                display: flex;
                height: 100%;
                background-color: var(--iframe-background-color) !important;
                color: var(--iframe-text-color) !important;
                font-size: var(--iframe-font-size) !important;
            "
        >
            <div
                v-for="(table, i) in setting.Tables"
                :key="i"
                :style="{
                    flex: `1 1 ${100 / (setting.Tables?.length == 0 ? 1 : setting.Tables?.length)}%`,
                    width: `${100 / (setting.Tables?.length == 0 ? 1 : setting.Tables?.length)}%`,
                }"
            >
                <ProductionTable
                    :table="table"
                    :setting="setting"
                    :preview="preview"
                />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import type { ProductionDeviceSetting } from '@/objects/generated';
import ProductionTable from './ProductionTable.vue';

const props = defineProps<{
    /**
     * The setting to display.
     */
    setting: ProductionDeviceSetting;

    /**
     * If true, the component is used in a preview. and will use preview data
     * instead of real data.
     */
    preview?: boolean;
}>();
</script>
